import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "emoji-face",
  "use": "emoji-face-usage",
  "viewBox": "0 0 88 88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 88 88\" id=\"emoji-face\">\n  <path d=\"M29 0h30v88H29z\" />\n  <path d=\"M18 6h52v76H18z\" />\n  <path d=\"M12 12h64v64H12z\" />\n  <path d=\"M6 18h76v52H6z\" />\n  <path d=\"M0 30h88v28H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol